import React, { useState } from "react";
import useTheme from "../hooks/useTheme";
import ThemeSelectorModal from "./ThemeSelectorModal";

const ThemeSelector = ({ variant = "navbar" }) => {
  const { currentTheme, changeTheme, currentPrimaryColor, changePrimaryColor } =
    useTheme();
  const [showModal, setShowModal] = useState(false);

  const handleThemeChange = (theme) => {
    changeTheme(theme);
  };

  return (
    <>
      {variant === "dropdown" ? (
        <button
          onClick={() => setShowModal(true)}
          className="p-2 dropdown-item h6 rounded-1 border-0 bg-transparent w-100 text-start d-flex align-items-center gap-2"
          title="Change Theme"
        >
          <span>Theme</span>
        </button>
      ) : (
        <li className="nav-item">
          <button
            className="nav-link nav-icon-hover-bg rounded-circle"
            onClick={() => setShowModal(true)}
            style={{
              border: "none",
              background: "transparent",
              padding: "8px",
            }}
            title="Change Theme"
          >
            <iconify-icon icon="solar:palette-line-duotone" className="fs-6" />
          </button>
        </li>
      )}

      <ThemeSelectorModal
        show={showModal}
        onHide={() => setShowModal(false)}
        currentTheme={currentTheme}
        currentPrimaryColor={currentPrimaryColor}
        onThemeChange={handleThemeChange}
        onPrimaryColorChange={changePrimaryColor}
      />
    </>
  );
};

export default ThemeSelector;
